import React from "react"
import Tooltip, { TooltipProps } from "@mui/material/Tooltip"
import { Box, styled } from "@material-ui/core"
import { InfoOutlined } from "@material-ui/icons"
import { useStyles } from "./style"

interface NoMatchProps {
  color?: "inherit" | "primary" | "secondary" | "action" | "error" | "disabled"
  showIconOnly?: boolean
  tooltipTitle?: JSX.Element | string;
  className?: string
}

const NoMatchToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& ul`]: {
    listStyleType: "disc",
    paddingLeft: "20px",
  },
}))

const NoMatch: React.FC<NoMatchProps> = ({
  color = "error",
  tooltipTitle,
  showIconOnly = false,
  className
}) => {
  const classes = useStyles()
  return (
    <Box className={`${classes.noMatch} ${className}`} data-testid="no-match-readonly-txt">
        <NoMatchToolTip title={tooltipTitle} arrow>
          <InfoOutlined fontSize="small" color={color} />
        </NoMatchToolTip>
      {!showIconOnly && "No Match"}
    </Box>
  )
}

export default NoMatch
